// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import createTypedReducer, { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { RecentShipmentsInformationModel } from "@stoneage/App/Services/RecentShipments/RecentShipmentsService";
import { Draft } from "immer";

export interface RecentShipmentItemInfoType {
    shipmentDate: string;
    invoiceNumber: string;
    invoiceAmount: string;
    poNumber: string;
    trackingNumber: string;
    trackingUrl: string;
    orderNumber: string;
    isVmiOrder: boolean;
    orderDate: string;
    isInternational: boolean;
}


type RecentShipmentsState = Readonly<{
    value?: RecentShipmentsInformationModel;
    hasAccessToOrderHistory: boolean;
    hasAccessToInvoiceHistory: boolean;
}>;

const initialRecentShipmentsState: RecentShipmentsState = {
    value: {} as any,
    hasAccessToOrderHistory: false,
    hasAccessToInvoiceHistory: false,
};

const reducer = {
    "xRecentShipments/setValue": (draft: Draft<RecentShipmentsState>, action: { value?: RecentShipmentsInformationModel }) => {
        draft.value = action.value;
    },
    "xRecentShipments/setUserHasAccessToOrderHistoryPage": (
        draft: Draft<RecentShipmentsState>,
        action: { value: boolean },
    ) => {
        draft.hasAccessToOrderHistory = action.value;
    },
    "xRecentShipments/setUserHasAccessToInvoiceHistoryPage": (
        draft: Draft<RecentShipmentsState>,
        action: { value: boolean },
    ) => {
        draft.hasAccessToInvoiceHistory = action.value;
    },
};

const xRecentShipments = createTypedReducerWithImmer(initialRecentShipmentsState, reducer);

(reducers as any).xRecentShipments = xRecentShipments;

export type xRecentShipmentsState = {
    xRecentShipments: RecentShipmentsState;
};

type xRecentShipmentsReducers = {
    value: typeof xRecentShipments;
    hasAccessToOrderHistory: typeof xRecentShipments;
    hasAccessToInvoiceHistory: typeof xRecentShipments;
};

export type xRecentShipmentsActions =
    | Parameters<xRecentShipmentsReducers[keyof xRecentShipmentsReducers]>[1]
    | AnyAction;
